import React, {useEffect, useRef} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isAgentTypeEnabled} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import {ButtonSize} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';

import StartChatInput from './StartChatInput';

interface InventoryAskButtonProps {
  itemId: string;
}

export default function InventoryAskButton({itemId}: InventoryAskButtonProps): JSX.Element | null {
  const hasTrackedImpression = useRef(false);
  const modelType = APIUtil.apiIdToType(itemId);
  useEffect(() => {
    hasTrackedImpression.current = false;
  }, [itemId]);

  useEffect(() => {
    if (isAgentTypeEnabled(AgentType.ASSISTANT) && !hasTrackedImpression.current) {
      hasTrackedImpression.current = true;
      trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.VIEWED_INVENTORY_ASK_BUTTON, {
        itemId,
        modelType,
      });
    }
  }, [itemId, modelType]);

  if (!isAgentTypeEnabled(AgentType.ASSISTANT)) {
    return null;
  }

  return (
    <StartChatInput
      itemId={itemId}
      agentType={AgentType.ASSISTANT}
      buttonSize={ButtonSize.SMALL}
      extraAnalyticsProperties={{source: 'inventory'}}
    />
  );
}
